import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotAuthorizedComponent, NotFoundComponent } from './shared/components';
import { LayoutComponent } from './layout/component/layout/layout.component';
import { AuthenticationCallbackComponent } from './core/components/authentication-callback/authentication-callback.component';
import { AuthGuardService } from './core/services/auth-guard.service';


const routes: Routes = [
  {
    path: '',
    redirectTo: '/sessions',
    pathMatch: 'full',
  },
  {
    path: 'auth-callback',
    component: AuthenticationCallbackComponent
  },
  {
    path: 'sessions',
    component: LayoutComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./session/session.module').then((m) => m.SessionModule),
  },
  {
    path: 'events',
    component: LayoutComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./event/event.module').then((m) => m.EventModule),
  },
  {
    path: 'audits',
    component: LayoutComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./audit/audit.module').then((m) => m.AuditModule),
  },
  {
    path: 'not-authorized',
    component: NotAuthorizedComponent
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
